<template>
    <div class="nnsp" v-if="OrderDetail.trip_title||OrderDetail.verify_arr.length!=0||OrderDetail.pay_arr.length!=0|| storeInfo.type == 2" :class="!swit&&'telies'">
      <div class="w-100 flex-wrap  mb-2" v-if="OrderDetail.verify_arr.length!=0 ||storeInfo.type == 2&&swit">
          <p>核&ensp;房&ensp;人：</p>
          <div class="lisd">
            <table align="center" cellpadding="10" cellspacing="5"  v-if="OrderDetail.verify_arr.length!=0">
              <tr >
                <th class="no-border nametlie">姓名</th>
                <th class="no-border">身份</th>
                <th class="no-border">手机号</th>
                <th v-if="storeInfo.type == 2&&swit&&OrderDetail.verify_arr.length!=0&&$GFUN.isInArray([6,7,8],OrderDetail.status)">
                  <i class="el-icon-circle-plus-outline meeq"  @click="getGuideInfo"  ></i>
                </th>
              </tr>
              <tbody v-for="(item,index) in OrderDetail.verify_arr" :key="index">
                <tr>
                  <td class="no-border">{{item.title||item.guide_name }}</td>
                  <td class="no-border w120" >{{item.flag==2?'领队':'导游'}}</td>
                  <td class="no-border">{{item.mob||item.guide_mobile}}</td>
                  <td v-if="storeInfo.type == 2&&swit&&$GFUN.isInArray([6,7,8],OrderDetail.status)" @click="delGuideInfo(item.id||item.guide_id,item.flag)">
                    <i class="el-icon-circle-close cions"></i>
                  </td>
                </tr>
              </tbody>
            </table>
            <i class="el-icon-circle-plus-outline outline" :class="OrderDetail.verify_arr.length!=0&&'outlineg'" @click="getGuideInfo" v-if="storeInfo.type == 2&&swit&&OrderDetail.verify_arr.length==0&&$GFUN.isInArray([6,7,8],OrderDetail.status)"></i>
            <span class="nols"   v-if="OrderDetail.verify_arr.length==0&&!swit ||OrderDetail.verify_arr.length==0&&$GFUN.isInArray([9],OrderDetail.status)">无</span>
          </div>
      </div>
      <div class="w-100 flex-wrap  mb-2" v-if="OrderDetail.pay_arr.length!=0 ||storeInfo.type == 2&&swit">
          <p>支&ensp;付&ensp;人：</p>
          <div class="lisd">
            <table align="center" cellpadding="10" cellspacing="5"  v-if="OrderDetail.pay_arr.length!=0">
              <tr >
                <th class="no-border nametlie">姓名</th>
                <th class="no-border">身份</th>
                <th class="no-border">手机号</th>
              </tr>
              <tbody v-for="(item,index) in  OrderDetail.pay_arr" :key="index">
                <tr>
                  <td class="no-border">{{item.title }}</td>
                  <td class="no-border w120">{{identity(item.flag)}}</td>
                  <td class="no-border">{{item.mob}}</td>
                  <td v-if="storeInfo.type == 2&&swit&&$GFUN.isInArray([6,7,8],OrderDetail.status)" @click="payDelete(item.id,item.flag)">
                    <i class="el-icon-circle-close cions"></i>
                  </td>
                </tr>
              </tbody>
            </table>
            <i class="el-icon-circle-plus-outline outline" :class="OrderDetail.pay_arr.length!=0&&'outlineg'" @click="getPayer" v-if="storeInfo.type == 2&&swit&&OrderDetail.pay_arr.length==0&&$GFUN.isInArray([6,7,8],OrderDetail.status)" ></i>
            <span class="nols"   v-if="OrderDetail.pay_arr.length==0&&!swit||OrderDetail.pay_arr.length==0&&$GFUN.isInArray([9],OrderDetail.status)">无</span>
          </div>
      </div>
      <div class="d-center-start w-100 flex-wrap mt-2 mb-2" v-if="swit">
        <p v-if="OrderDetail.trip_title||storeInfo.type==2">入住名单：</p>
        <div class="infoPro  d-center-start " v-if="!OrderDetail.trip_title&&storeInfo.type==2&&$GFUN.isInArray([6,7,8],OrderDetail.status)" >
          <el-progress v-if="fileProgressNum > 0" :percentage="fileProgressNum" />
          <a v-else href="javascript:;" class="file">选择文件
            <input type="file" accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.png,.jpeg" @change="chooseFile">
          </a>
          <!-- <div class="ml-2 text-muted inline">(文件大小5M以内。文件格式为：.doc、.docx、xls、xlsx、.pdf、.jpg、.jpeg、.png。推荐上传word文件，如：.doc或.docx)</div> -->
        </div>
        <div v-else class="d-center-start w-60">
          <div  class="text-link text-left" @click="toEleMsg">
            {{OrderDetail.trip_title}}
          </div>
          <i class="el-icon-edit bianjs" @click='bianqs=1,showEdit=true' v-if="storeInfo.type == 2&&$GFUN.isInArray([6,7,8],OrderDetail.status)"></i>
          <i class="el-icon-circle-close liens"  @click="deleteFile" v-if="storeInfo.type == 2&&$GFUN.isInArray([6,7,8],OrderDetail.status)"></i>
          <div class="mob" v-if="bianqs==1">
            <div class="nrk">
              <span>请输入要修改的名称</span>
              <el-input v-model="editEleTitle"  class="w-80">
              <template slot="append">.{{cut(OrderDetail.trip_title,1)}}</template>
              </el-input>
              <div class="w-100 text-center anlie">
                <span class="text-linpp" @click="editFile">确定</span>
                <!-- <span class="text-linpp">删除</span> -->
                <span class="text-linpp" @click="bianqs=0,showEdit = false">取消</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="dialogVisible" class="addGuide" width='30%' :before-close="handleClose" @close="guideClose">
          <div  v-if="staff==true||tab==2||tab==3"  class="searchFor">
            <div class="sel">
              <el-select v-model="value" placeholder="请选择">              
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </div>
            <input v-model="search" class="sel-input"  @keyup.enter="staff?getGuideInfo():getPayer()">
            <div class="forButton" @click="staff?getGuideInfo():getPayer()">搜索</div>
          </div>
          <!-- <el-input v-model="search" @change="getGuideInfo('search')" class="searchBorder" suffix-icon="el-icon-search" placeholder="姓名/手机号..." /> -->
          <h2 class="lelte" v-else>设置支付人</h2>
          <!-- <div v-if="JSON.stringify(this.chooseGuide) != '{}'" class="pt-2 pb-2"><span class="text-muted">已选：</span>
          <el-tag closable :disable-transitions="false"  @close="chooseGuide = {}">{{chooseGuide.title}}</el-tag>
          </div> -->
          <!--核审人-->
          <el-tabs v-model="tab" class="mt-1 mb-3 pr-3" @tab-click="tabClick" v-if="staff==true">
            <el-tab-pane v-if="!isAdmin" label="导游" name="0" />
            <el-tab-pane label="领队" name="1" />
          </el-tabs>
           <!--支付人-->
          <el-tabs v-model="tab" class="mt-1 mb-3 pr-3" @tab-click="getPayer" v-else>
            <el-tab-pane label="预订人支付" name="0" />
            <el-tab-pane label="核房人支付" name="1" />
            <el-tab-pane label="导游支付" name="2" />
            <el-tab-pane label="领队支付" name="3" />
          </el-tabs>
          <el-scrollbar class="mincontent">
            <el-row  class="border-bottom  pb-1 pr-3 " >
                <el-col :span="6" class="text-blue">名称</el-col>
                <el-col :span="8" class="text-blue">手机号</el-col>
                <el-col :span="10" class="text-right col-3 text-blue">操作</el-col>
            </el-row>
            <div v-if="guides.length == 0" class="text-center">
                <div class="text-muted h5 mt-6 mb-4">没有搜索结果{{staff?'去添加':''}}</div>
            </div>
            <template v-for="(item,index) in guides">
              <el-row  class="border-bottom pt-1 pb-1 pr-3"  :key="index" v-if="guides.length != 0">
                  <!-- <el-col :span="4">
                    <img :src="item.avatar?ImgPreUrl+item.avatar : '/images/public/defaultImg.png'" width="45" height="45" alt="">
                  </el-col> -->
                  <el-col :span="6">{{item.title}}
                  <i v-if="item.sex == 1" style="color: #afd4f4" class="iconfont icon-nan ml-1"></i>
                  <i v-if="item.sex == 2" style="color: #f1a2cf" class="iconfont icon-nv ml-1"></i>
                  </el-col>
                  <el-col :span="8">{{item.mob}}</el-col>
                  <el-col :span="10" class="text-right">
                  <el-button :class="{'active' : index == current}" size="mini" @click="tabTenSure(item, index)">
                      <!-- {{verify_arr.guide_mobile == item.mob ? '已选' : ''}} -->
                      选择Ta
                  </el-button>
                  </el-col>
              </el-row>
            </template>
          </el-scrollbar>
          <el-pagination background layout="prev, pager, next" class="mt-4 text-center"
          v-if="guides.length > 0&&tab>=2" :page-size="10" :total="total" :current-page=page
              @current-change="v => {page=v; getGuideInfo()}"/>
          <span slot="footer" class="dialog-footer">
          <el-button type="liasq" @click="addGuide"  v-if="staff||tab==2||tab==3">添加新人</el-button>    <!--@click="$router.push({name: 'AddGuide',query:{store:$route.query.storeId,tab:tab==2?1:tab,staff:staff?1:2}})"-->
          <!-- <el-button type="primary" @click="enSureInfo">确 定</el-button> -->
          </span>
      </el-dialog>
      <el-dialog title="添加新人" :visible.sync="showConfirmPanel" width="50%" center id="loadConfirm">
          <AddGuide :staff='dialogVisible' :staffTab='staffTab'  @addGuideList="addGuideList" v-if="showConfirmPanel"></AddGuide>
        <div slot="footer"></div>
      </el-dialog>
    </div>
</template>

<script>
import { mapState,mapActions,mapGetters } from 'vuex'
import AddGuide from '../../../StoreInfo/GuideManage/AddGuide.vue'
export default {
    name: 'setGuide',
    data () { 
        return {
            search: '',
            showConfirmPanel:false,
            dialogVisible: false,
            fileProgressNum: 0,
            subscription: null,
            fileInfo:null,
            editEleTitle: '',
            guides: [],
            chooseGuide: {},
            tab: "0",
            current: -1,
            total: 0,
            page: 1,
            showEdit: false,
            bianqs:0,
            staff:true,   //核实人身份切换
            PaymentPersonnel:[],                //付款人员
            value:0,
            options: [{
                value: 0,
                label: '按手机号'
              }, {
                value: 1,
                label: '按姓名'
             }],
             staffTab:0,
        }
    },
    components:{AddGuide},
    props:{
      swit:{
        type: Boolean,
        default: true},
    },
    computed: {
      ...mapState(['OrderDetail']),
      ...mapGetters(['userInfo','storeInfo','isAdmin']),
      showGuide () {
        return this.$GFUN.isInArray([0,4,6,7,8,9],this.OrderDetail.status*1) && (this.storeInfo.type == 2 )
      } 
    },
    created () {
      if (this.OrderDetail.trip_title) this.editEleTitle = this.cut(this.OrderDetail.trip_title,0)
    },
    watch: {
      OrderDetail () {
        if (this.OrderDetail.trip_title) this.editEleTitle = this.cut(this.OrderDetail.trip_title,0)
      }
    },
    methods: {
      ...mapActions(['delGuide','getGuide','enSure','payer','payerDelete']),
      //关闭支付人/核房人清空搜索值
      guideClose(){
        this.search='';
      },
      handleClose(){
        this.tab="0";
        this.dialogVisible=false;
      },
      //开启添加信息
      addGuide(){
        this.staffTab=this.tab>=2?this.tab*1-2:this.tab;
        console.log(this.staffTab)
        this.showConfirmPanel=true
      },
      //关闭添加信息
      addGuideList(){
        this.showConfirmPanel=false;
        this.page=1;
        if(this.staff){
           this.getGuideInfo()
        }else{
           this.getPayer()
        }
      },
      // 切换所有和已添加
      tabClick () {
        this.page=1;
        this.search = ''
        this.getGuideInfo()
      },
      //上传文件到七牛
      async chooseFile(e) {
        if (e.target.files[0].size > 5 * 1024 * 1024) {
          this._alert('文件超过5M，请选择5M以内的文件',null,'error')
        } else this.fileInfo = e.target.files[0];
        let next = res => this.fileProgressNum = Number((res.total.percent).toFixed(2));
        let complete = res => this.saveFileName('file',res.key);
        let error = res => console.log(res);
        let observable = await this.$GFUN.UploadFileToQiniu(this.fileInfo);
        this.subscription = observable.subscribe(next, error, complete);
      },
      // 截取文件后缀名
      cut (name,index) {
          //index为1截取后缀 为0截取前缀
          let fileName = name.lastIndexOf("."); //取到文件名开始到最后一个点的长度
          let fileNameLength = name.length; //取到文件名长度
          let lastFormat = name.substring(fileName + 1, fileNameLength); //截
          let firstFormat = name.substring(0, fileName)
          if (index == 1) return lastFormat;
          else return firstFormat;
      },
      /*保存电子行程单*/
      async saveFileName(type,saveText) {
        const submitFun = async () => {
          let res = await this.$axios.post('/pc/Travel/OrderHotelSetTrip',{
            store_id: this.storeInfo.storeId,
            trip: saveText,
            oid: this.$route.query.orderId,
            trip_title: this.fileInfo.name
          });
          if (res.code === '00000') this._alert('电子入住名单已上传！',() => {
            this.fileProgressNum = 0;
            this.fileInfo = null;
            this.$emit('getDetail')
          })
        }
        submitFun();
      },
      async editFile () {
        this.showEdit=!this.showEdit
        if (!this.showEdit) {
          if (!this.editEleTitle) { this.$message.warning('文件名不能为空！'); return}
          this._confirm(`确定编辑文件名为 ${this.editEleTitle} 么？`,async () => {
            let res = await this.$axios.post('/pc/Travel/OrderHotelRenameTrip',{
              store_id: this.storeInfo.storeId,
              oid: this.$route.query.orderId,
              trip_title: this.editEleTitle + '.' + this.cut(this.OrderDetail.trip_title,1)
            });
            if (res.code === '00000') this._alert('编辑成功！',() => this.$emit('getDetail'))
          })
        }
      },
      async deleteFile () {
        this._confirm('确定删除该文件么？',async () => {
          let res = await this.$axios.post('/pc/Travel/OrderHotelDelTrip',{
            store_id: this.storeInfo.storeId,
            oid: this.$route.query.orderId,
          });
          if (res.code === '00000') this._alert('已删除！',() => this.$emit('getDetail'))
        })
      },
      // 导游详情页
      goGuideDetail () {
        if (this.isAdmin) this.$router.push({name:'StoreDetail',query:{type:4, id: this.OrderDetail.guide_id, look: 0}})
      },
      choose (item, index) {
        this.chooseGuide = {}; this.chooseGuide = item; this.current = index
      },
      //搜索
      
      // 开启支付人
      getPayer(search){
          if (search) this.page = 1;
          this.dialogVisible = true;
          this.staff=false;
          this.chooseGuide={};
          let data='';
          switch (this.tab*1) {
            case 1:
            data=this.OrderDetail.verify_arr; this.guides=data ||[];
            break;
            case 0:
            data=[{
              id:this.OrderDetail.send_store_id,
              guide_id:this.OrderDetail.send_store_id,
              mob:this.OrderDetail.send_mobile,
              guide_mobile:this.OrderDetail.send_mobile,
              title:this.OrderDetail.send_name,
              guide_name:this.OrderDetail.send_name,
            }]
            this.guides=data ||[];
            break;
            default:
              this.getGuide({
                data: {
                  all_flag:this.tab*1-2,
                  store_id: this.storeInfo.storeId,
                  mobile: this.value==0?this.search:'',
                  title: this.value==1?this.search:'',
                  page: this.page,
                  call:1,
                  num: 10
                },
                successFun: (res) => {
                  this.guides = res.data.list || [];
                  this.total = res.data.count || 0;
                }
              });
            break;
          }
         
      },
      // 开启核审人
      getGuideInfo (search) {
        this.chooseGuide={};                 //清空已选
        this.staff=true;
        if (search) this.page = 1;
        this.getGuide({
          data: {
            all_flag: this.tab,
            store_id: this.storeInfo.storeId,
            mobile: this.value==0?this.search:'',
            title: this.value==1?this.search:'',
            page: this.page,
            call:1,
            num: 10
          },
          successFun: (res) => {
            this.guides = res.data.list || [];
            this.total = res.data.count || 0;
            this.dialogVisible = true
          }
        })
      },
      tabTenSure(item,index){
        let text='是否设置['+item.title+']为';
        let n=this.staff?'核房人':'支付人';
         this._confirm(text+n,() => {
          this.chooseGuide=item;
          this.enSureInfo();
        })
      },
      enSureInfo () {
      //设置核房人
      if(this.staff){
        this.enSure({
          chooseGuide: this.chooseGuide,
          flag:this.tab*1+1,
          successFun: () => {
            this._alert('添加成功!', () => {
              this.$emit('getDetail')
              this.dialogVisible = false
            });
          }
        })
      }else{
        //设置支付人
        this.payer({
            chooseGuide: this.chooseGuide,
            flag:this.tab*1+1,
            successFun: () => {
              this._alert('添加成功!', () => {
                this.$emit('getDetail')
                this.dialogVisible = false
              });
            }
        })
        // data.push(this.chooseGuide)
        // this.PaymentPersonnel=data;
        // console.log(this.PaymentPersonnel)
      }
      },
      //删除支付人
      payDelete(guide_id,flag){
       this.payerDelete({id:guide_id,flag:flag,successFun: () =>{ 
          this._alert('删除成功!', () => {
              this.$emit('getDetail')
              this.dialogVisible = false
            });
          
        }})
      },
      //删除审核人
      delGuideInfo (guide_id,flag) {
        this.delGuide({id:guide_id,flag:flag,successFun: () =>{ 
          this._alert('删除成功!', () => {
              this.$emit('getDetail')
              this.dialogVisible = false
            });
          
        }})
      },
      //身份判断
      identity(i){
        let text=''
        switch (i*1) {
          case 1:text='导游';break;
          case 2:text='领队';break;
          case 100:text='预订人';break;
        }
        return text
      },
      toEleMsg () {
        window.open(this.ImgPreUrl + this.OrderDetail.trip,'_blank')
      }
    }
}
</script>

<style lang="scss" scoped>
  .infoPro{
    width: 100px;
  }
  .col-3{
   padding-right: 20px;
  }
  .forButton{
    float: left;
    background-color: #12b2ca;
    width: 60px;
    text-align: center;
    line-height: 37px;
    border-radius: 0 5px 5px 0;
    color: #fff;
    margin-top: 1px;
    cursor: pointer;
  }
  .searchFor{
    display: flex;
    justify-content: center;
  }
  .sel{
    width: 110px;
  }
  .sel-input{
   height: 37px;
   margin-top: 1px;
   border: 1px #12b2ca solid;
   border-left: 0;
   width: 120px;
   padding: 0 10px;
   outline: none;
  }
  .lelte{
    text-align: center;
    color: #333;
  }
  .searchFor{
    overflow: hidden;
  }
  .meeq{
    font-size: 18px;
    color: #60c9fd;
  }
  .mob{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, .6);
    z-index: 999;
  }
  .mob .nrk>span{
    text-align: center;
    margin-bottom: 16px;
    display: block; 
  }
  .mob .nrk{
    background-color: #fff;
    padding: 16px 0;
    width: 300px;
    margin: 0 auto;
    overflow: hidden;
    border-radius: 5px;
    margin-top: 15%;
  }
  .anlie{
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  .anlie span:nth-child(1){
    background-color:var(--smtc-color-primary);
    color: #fff;
    width: 70px;
    height: 34px;
    text-align:center;
    display: inline-block;
    margin-right: 40px;
    border-radius: 5px;
    line-height: 34px;
  }
  .anlie span:nth-child(2){
    border: 1px #eee solid;
    color: #999;
    width: 70px;
    height: 34px;
    text-align:center;
    display: inline-block;
    border-radius: 5px;
    line-height: 34px;
  }
  .liens{
    float: left;
    font-size: 18px;
    color: red !important;
    margin-left: 12px;
    margin-top: 1px;
    cursor: pointer;
  }
  .nols{
    width: 100px;
    text-align: left;
    float: left;
    font-size: 12px;
  }
  .outline{
    font-size: 18px;
    color: #60c9fd;
    margin-top: 2px;
    cursor: pointer;
    width: 100px;
    float: left;
    text-align: left;
  }
  .outlineg{
    width: 166px;
    text-align: center;
    margin-top: 8px;
  }
  .lisd{
    justify-content:center;
    overflow: hidden;
  }
  .lisd th,.lisd td{
    padding: 4px 10px;
    font-size: 12px;
  }
.nnsp{
  border-bottom: 1px #eee solid;
  padding: 16px 0;
  overflow: hidden;
}
.nnsp p{
  margin-left: 86px;
  padding-left: 1rem;
  width: 70px;
  text-align: right;
  float: left;
}
.telies p{
  font-size: 12px;
  width: 60px;
}
.mincontent{
  height: 40vh;
}
.file {
    position: relative;
    display: inline-block;
    background: #61DAF3;
    border-radius: 4px;
    padding: 2px 12px;
    overflow: hidden;
    color: #fff;
    text-decoration: none;
    text-indent: 0;
    line-height: 24px;
    width: 150px;
    text-align: center
}
.file input {
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0;
}
.bianjs{
  color: var(--smtc-color-primary);
  font-size: 16px;
  margin-left: 12px;
  padding-top: 4px;
  cursor: pointer;
}
.text-linpp{
  cursor: pointer;
  color: var(--smtc-color-primary);
}
.cions{
  font-size: 18px;
  color: red !important;
}
.no-border {
  border:1px #333 solid;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.w120{
  width: 40px;
}
.nametlie{
  width: 50px;
}
</style>
<style >
  .sel .el-input__inner{
    background-color: #12b2ca;
    color: #fff;
    border-radius: 5px 0 0 5px;
  }
  .sel  .el-select .el-input .el-select__caret{
    color: #fff;
  }
</style>